document.addEventListener("DOMContentLoaded", () => {
  $(document).on('click', '.product-keypart-detail', function () {
    loadModal({
      title: `Keypart Detail for QR Code Product ${$(this).text()}`,
      url: `/second_process/daily_reports/${$(this).attr('rid')}/keypart_detail`
    })
  })
})